import { createAsyncThunk } from "@reduxjs/toolkit";

import { isAppLanguage, type AppLanguage } from "@fitness-app/data-models/entities/AppLanguage";
import { type TraineeSettings } from "@fitness-app/data-models/entities/TraineeSettings";

import { type AsyncThunkCreator } from "../../../index";
import { TRAINEE_REDUCER_NAME } from "../types";

type Payload = { id: string; userId: string; language: AppLanguage };

export const updateTraineeLanguage = createAsyncThunk<TraineeSettings, Payload, AsyncThunkCreator<string>>(
  `${TRAINEE_REDUCER_NAME}/updateTraineeLanguage`,
  async ({ id, userId, language }, { rejectWithValue, extra: { db } }) => {
    if (!isAppLanguage(language) || !userId) {
      return rejectWithValue("Invalid language preference");
    }

    const { data, error } = await db
      .from("trainee_settings")
      .update({ language, updatedAt: new Date().toISOString() })
      .eq("id", id)
      .eq("userId", userId)
      .select("*")
      .single<TraineeSettings>();

    if (error || !data) {
      return rejectWithValue(error?.message || "Failed to update language");
    }

    return data;
  },
);
